import { createElement, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu } from "./Menu";
import { useAuth } from "../auth/AuthContext";
import { getNavigationRoutes } from "../router/routes";
export var MenuContainer = function (_a) {
    var _b = _a.displayMode, displayMode = _b === void 0 ? "sidebar" : _b;
    var navigate = useNavigate();
    var location = useLocation();
    var role = useAuth().role;
    var navigationItems = getNavigationRoutes()
        .filter(function (route) {
        var _a;
        if (route.path === "/profile") {
            return false;
        }
        if ((_a = route.allowedRoles) === null || _a === void 0 ? void 0 : _a.length) {
            return Boolean(role && route.allowedRoles.includes(role));
        }
        return true;
    })
        .map(function (route) { return ({
        icon: route.icon,
        label: route.navigationLabel || route.title,
        path: route.path,
    }); });
    var onClickItem = useCallback(function (key) {
        navigate(key);
    }, [navigate]);
    var props = {
        currentPath: location.pathname,
        displayMode: displayMode,
        navigationItems: navigationItems,
        onClickItem: onClickItem,
    };
    return createElement(Menu, props);
};
